import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Dispatch, useEffect } from 'react';
import { AnyAction } from 'redux';
import { dateTimeResponseMap } from '../helpers';
import { AppPermissions, conciliationsStatusKeys } from '../types';

import {
  findConciliationHeaderRequested,
  reportConciliationHeaderLoadingSelector,
  changeFilterCountry,
  changeFilterStartAccountingDate,
  changeFilterEndAccountingDate,
} from '../state';

import {
  CountryFilter,
  ReportFilters,
  StoreFilter,
  FranchiseTypeFilter,
  FederativeEntityFilter,
  AccountingDateRangeFilter,
} from './ReportFilters';

import { PermissionsProvider } from './Permissions';
import ConciliationHeaderFilterActions from './ConciliationHeaderFilterActions';

const onedriveAction = () => findConciliationHeaderRequested(true);

const handleSearchParams = (dispatch: Dispatch<AnyAction>, searchParams: URLSearchParams) => {
  const countryCode = searchParams.get(conciliationsStatusKeys.country);
  const startDate = dateTimeResponseMap(
    searchParams.get(conciliationsStatusKeys.startDate)
  ) as Date;
  const endDate = dateTimeResponseMap(searchParams.get(conciliationsStatusKeys.endDate)) as Date;

  if (countryCode && startDate && endDate) {
    dispatch(changeFilterStartAccountingDate(startDate));
    dispatch(changeFilterEndAccountingDate(endDate));
    dispatch(changeFilterCountry(countryCode));

    dispatch(findConciliationHeaderRequested());
  }
};

const ConciliationHeaderSearch = () => {
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  useEffect(() => {
    handleSearchParams(dispatch, searchParams);
  }, [dispatch, searchParams]);

  return (
    <ReportFilters
      loadingSelector={reportConciliationHeaderLoadingSelector}
      applyAction={findConciliationHeaderRequested}
      onedriveAction={onedriveAction}
      showOpStructureFilters
    >
      <PermissionsProvider resourcePermissions={[AppPermissions.CONCILIATIONS_HEADER]}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={2} lg={2} xl>
            <CountryFilter fullWidth />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl>
            <FederativeEntityFilter />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl>
            <StoreFilter />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl>
            <FranchiseTypeFilter />
          </Grid>
          <Grid item xs={12} md lg xl={3}>
            <AccountingDateRangeFilter spacing={1} />
          </Grid>
          <Grid item xs={12} md lg xl>
            <ConciliationHeaderFilterActions />
          </Grid>
        </Grid>
      </PermissionsProvider>
    </ReportFilters>
  );
};

export default ConciliationHeaderSearch;
